var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 11C11.75 10.5858 11.4142 10.25 11 10.25H5C4.58579 10.25 4.25 10.5858 4.25 11C4.25 11.4142 4.58579 11.75 5 11.75H11C11.4142 11.75 11.75 11.4142 11.75 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15C11.75 14.5858 11.4142 14.25 11 14.25H5C4.58579 14.25 4.25 14.5858 4.25 15C4.25 15.4142 4.58579 15.75 5 15.75H11C11.4142 15.75 11.75 15.4142 11.75 15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.25C1.48122 0.25 0.25 1.48122 0.25 3V17C0.25 18.5188 1.48122 19.75 3 19.75H13C14.5188 19.75 15.75 18.5188 15.75 17V5.96766C15.75 5.58689 15.6258 5.21651 15.3963 4.9127L12.3985 0.945042C12.0677 0.507298 11.5509 0.25 11.0022 0.25H3ZM1.75 3C1.75 2.30964 2.30964 1.75 3 1.75H10.25V6.14705C10.25 6.56126 10.5858 6.89705 11 6.89705H14.25V17C14.25 17.6904 13.6904 18.25 13 18.25H3C2.30964 18.25 1.75 17.6904 1.75 17V3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.0af10c61b54df45d21691b3746286d98.svg";
export { ForwardRef as ReactComponent };